import * as React from 'react';
// import * as ReactDOM from 'react-dom/client';
import ReactDOM from 'react-dom';
import Router from '@/router';
import { TIANQI_UBT } from '@/utils/ubt';
import '@/styles/global.less';
import { vConsoleSDK } from './utils/asyncImportJs';
import { getUrlParams } from './utils';

TIANQI_UBT.setConfig();
TIANQI_UBT.bindData({});

const { vConsole = '' } = getUrlParams(window.location.href || '');

if (
  !['pro', 'pre'].includes(process.env.REACT_APP_ENV || '') ||
  +vConsole === 1
) {
  vConsoleSDK().then(() => {
    if ((window as any).VConsole) {
      new (window as any).VConsole();
    }
  });
}

// ReactDOM.createRoot(document.getElementById('app') || document.body).render(
//   <Router />,
// );

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<Router />, document.getElementById('app'));
